import * as React from "react"
import { cn } from "./button"

const Input = React.forwardRef(({ className, type, hasError, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-[var(--hp-radius-md)] border border-[var(--hp-color-border)] bg-[var(--hp-color-surface)] px-3 py-2 text-sm text-[var(--hp-color-text)] transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[var(--hp-color-text-subtle)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--hp-color-focus)] disabled:cursor-not-allowed disabled:bg-[var(--hp-color-surface-muted)] disabled:text-[var(--hp-color-text-disabled)]",
        hasError && "border-[var(--hp-danger-600)] focus-visible:ring-[var(--hp-danger-600)] bg-[var(--hp-danger-50)] text-[var(--hp-danger-700)]",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }
export default Input;
